module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pay-in__body px-4 py-4"
  }, [_c('label', {
    staticClass: "mb-3"
  }, [_vm._v("Select payment scope")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "pay-in__scope-card mr-3",
    class: {
      'pay-in__scope-card--selected': _vm.isSelected(_vm.PAYMENT_SCOPE.FULL_BOOKING)
    },
    on: {
      "click": function($event) {
        return _vm.$emit('input', _vm.PAYMENT_SCOPE.FULL_BOOKING)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-credit-card mb-2 fs-large",
    class: _vm.isSelected(_vm.PAYMENT_SCOPE.FULL_BOOKING) ? 'pay-in__selected-color' : 'dark'
  }), _vm._v(" "), _c('strong', {
    staticClass: "font-weight-600",
    class: {
      'pay-in__selected-color': _vm.isSelected(_vm.PAYMENT_SCOPE.FULL_BOOKING)
    }
  }, [_vm._v("Full booking")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "pay-in__scope-card",
    class: {
      'pay-in__scope-card--selected': _vm.isSelected(_vm.PAYMENT_SCOPE.PARTIAL_ITEMS),
      'pay-in__scope-card--disabled': _vm.isFirstPaymentFull
    },
    style: ({
      cursor: _vm.isFirstPaymentFull ? 'not-allowed' : 'pointer',
      opacity: _vm.isFirstPaymentFull ? 0.5 : 1
    }),
    on: {
      "click": function($event) {
        !_vm.isFirstPaymentFull && _vm.$emit('input', _vm.PAYMENT_SCOPE.PARTIAL_ITEMS)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-list mb-2 fs-large",
    class: _vm.isSelected(_vm.PAYMENT_SCOPE.PARTIAL_ITEMS) ? 'pay-in__selected-color' : 'dark'
  }), _vm._v(" "), _c('strong', {
    staticClass: "font-weight-600",
    class: {
      'pay-in__selected-color': _vm.isSelected(_vm.PAYMENT_SCOPE.PARTIAL_ITEMS)
    }
  }, [_vm._v("Partial item payments")]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end align-items-center mt-4"
  }, [_c('label', {
    staticClass: "mr-2 fs-medium"
  }, [_vm._v("Due to Pay")]), _vm._v(" "), _c('span', {
    staticClass: "fs-large font-weight-600 mr-4"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.amountDue)) + " €")]), _vm._v(" "), _c('label', {
    staticClass: "mr-2 fs-medium"
  }, [_vm._v("Total")]), _vm._v(" "), _c('span', {
    staticClass: "fs-large font-weight-600"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.grandTotal)) + " €")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "fs-small dark mt-1"
  }, [_vm._v("Pay the full reservation balance or a partial"), _c('br'), _vm._v("amount of the total")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "fs-small dark mt-1"
  }, [_vm._v("Select specific ticket types and extras"), _c('br'), _vm._v("to pay for")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6560d0e4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6560d0e4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationPayIn/Step1Scope.vue
// module id = 1992
// module chunks = 0